import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { Grid, IconButton, Link } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import DialogCalendar from '../../components/dialog/dialogcalendar';
import { Circle } from '@mui/icons-material';
import { getToken } from '../../utils/common';

// Helper functions moved to outer scope for better performance
function handleClickLang(lang) {
  i18next.changeLanguage(lang);
}

export default function CalendarPage() {
  const currentDate = new Date();
  const [year, setYear] = React.useState(currentDate.getFullYear());
  const currentMonthNumber = currentDate.getMonth() + 1;
  const [month, setMonth] = React.useState(currentMonthNumber);
  const daysArray = getDaysArrayByMonth(year, month);
  const [data, setData] = React.useState([]);
  const [calendardialog, setCalendarDialog] = React.useState({
    open: false,
    data: [],
    date: '',
  });
  const [search] = React.useState('');

  const fetchInfo = (url) =>
    fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => setData(d.data));
  const handlemonth = (e) => {
    if (month >= 12) {
      setYear(year + 1);
      setMonth(1);
      fetchInfo(`${globalThis.REACT_APP_API_PURE}calendar/list?month=1` + `&year=${year + 1}`);
    } else {
      setMonth(month + 1);
      fetchInfo(`${globalThis.REACT_APP_API_PURE}calendar/list?month=${month + 1}&year=${year}`);
    }
  };
  const handlemonthback = (e) => {
    if (month <= 1) {
      setYear(year - 1);
      setMonth(12);
      fetchInfo(`${globalThis.REACT_APP_API_PURE}calendar/list?month=12` + `&year=${year - 1}`);
    } else {
      setMonth(month - 1);
      fetchInfo(`${globalThis.REACT_APP_API_PURE}calendar/list?month=${month - 1}&year=${year}`);
    }
  };

  React.useEffect(() => {
    fetchInfo(`${globalThis.REACT_APP_API_PURE}calendar/list`);
  }, []);

  function Refresh() {
    fetchInfo(`${globalThis.REACT_APP_API_PURE}calendar/list`);
  }

  function getDaysArrayByMonth(year, month) {
    const daysArray = [];
    const startDate = new Date(year, month - 1, 1);
    const endDate = new Date(year, month, 0);

    for (let d = new Date(startDate); d <= endDate; d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1)) {
      daysArray.push(d);
    }

    return daysArray;
  }
  function getDayName(date) {
    const days = [t('day.1'), t('day.2'), t('day.3'), t('day.4'), t('day.5'), t('day.6'), t('day.7')];
    // Accept Date object directly to avoid parsing issues
    const dateObj = date instanceof Date ? date : new Date(date);
    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      return '';
    }
    const dayName = days[dateObj.getDay()];
    return dayName;
  }
  function getDayNumber(date) {
    // Accept Date object directly to avoid parsing issues
    const dateObj = date instanceof Date ? date : new Date(date);
    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      return NaN;
    }
    const dayNumber = dateObj.getDate();
    return dayNumber;
  }
  function formatDate(dateInput) {
    // Accept Date object or ISO string, but not locale-specific strings
    let date;
    if (dateInput instanceof Date) {
      date = dateInput;
    } else if (typeof dateInput === 'string') {
      // Handle API date format like "2025-10-18 22:38:42Z" or "2025-10-18T22:38:42Z"
      if (dateInput.includes('T')) {
        // ISO format with T separator
        date = new Date(dateInput);
      } else if (dateInput.match(/^\d{4}-\d{2}-\d{2} /)) {
        // Format like "2025-10-18 22:38:42Z" - replace space with T for proper parsing
        const isoString = dateInput.replace(' ', 'T');
        date = new Date(isoString);
      } else if (dateInput.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // Date-only format like "2025-10-18" - add time for consistent parsing
        date = new Date(dateInput + 'T00:00:00');
      } else {
        // Try parsing as-is, but this may fail in Firefox
        date = new Date(dateInput);
      }
    } else {
      date = new Date(dateInput);
    }

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return '';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  function DayCard({ date, index }) {
    const isCurrentDate = date.toDateString() === currentDate.toDateString();

    const filteredData = data?.filter((d) => {
      // First filter out items with empty schedules
      if (!d.schedule || d.schedule.trim() === '') {
        return false;
      }
      // Then filter by date - use Date object directly instead of toLocaleDateString()
      return formatDate(d.time_start) === formatDate(date);
    });

    return (
      <button
        type="button"
        onClick={() => {
          if (filteredData.length > 0) {
            setCalendarDialog({
              open: true,
              data: filteredData,
              date: isCurrentDate,
            });
          }
        }}
        style={{
          height: 90,
          padding: '10px',
          width: '50%',
          textAlignLast: 'center',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        {index === 0 ? (
          <div>
            <Typography variant="caption" style={{ color: '#888888' }}>
              {getDayName(date)}
            </Typography>
          </div>
        ) : (
          ''
        )}
        <div
          style={{
            backgroundColor: isCurrentDate ? '#1EB3D9' : 'transparent',
            color: isCurrentDate ? 'white' : index === 28 && getDayNumber(date) < 28 ? '#B0B0B0' : 'black',
            display: isCurrentDate ? 'inline-flex' : '',
            padding: isCurrentDate ? 2 : '',
            borderRadius: 5,
          }}
        >
          <Typography variant="caption">{getDayNumber(date)}</Typography>
        </div>
        {filteredData?.length === 0 || filteredData === undefined ? (
          ''
        ) : (
          <Grid container direction={'row'} justifyContent={'center'}>
            {' '}
            {filteredData
              ?.filter((d) => {
                if (search === '') {
                  return d;
                }
                return d.title.toLowerCase().includes(search.toLowerCase());
              })
              .map((d, index) => {
                if (index < 3) {
                  return (
                    <Grid item>
                      <Circle
                        fontSize="1px"
                        style={{
                          height: 5,
                          paddingRight: 2,
                          width: 5,
                          color: d.schedule === 'Daily' ? '#1EB3D9' : d.schedule === 'Weekly' ? '#8667EB' : '#F9A207',
                        }}
                      />
                    </Grid>
                  );
                }
                return null;
              })}
            <Grid />
            {filteredData.length <= 3 ? (
              ''
            ) : (
              <Link
                onClick={() => {
                  if (filteredData.length > 0) {
                    setCalendarDialog({
                      open: true,
                      data: filteredData,
                      date: isCurrentDate,
                    });
                  }
                }}
              >
                {/* <Typography variant="caption">{filteredData.length - 3} more</Typography> */}
              </Link>
            )}{' '}
          </Grid>
        )}
      </button>
    );
  }

  DayCard.propTypes = {
    date: PropTypes.instanceOf(Date),
    index: PropTypes.number,
  };
  const { t } = useTranslation();

  function DayList({ daysArray }) {
    const rows = [];

    const getDaysArrayByMonth = (year, month) => {
      const daysInMonth = new Date(year, month, 0).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => new Date(year, month - 1, i + 1));
    };

    const remainingDays = 35 - daysArray.length;

    const nextMonth = getDaysArrayByMonth(year, month + 1);

    const paddedDaysArray = [...daysArray, ...nextMonth.slice(0, remainingDays)];

    for (let i = 0; i < paddedDaysArray.length; i += 7) {
      const rowDays = paddedDaysArray.slice(i, i + 7);
      rows.push(
        <div style={{ display: 'flex' }} key={i}>
          {rowDays.map((day, index) => (
            <DayCard key={`day-${i}-${index}`} date={day} index={i} />
          ))}
        </div>
      );
    }

    return <div>{rows}</div>;
  }

  function DayCardRight({ date, index }) {
    const isCurrentDate = date.toDateString() === currentDate.toDateString();

    const filteredData = data?.filter((d) => {
      // First filter out items with empty schedules
      if (!d.schedule || d.schedule.trim() === '') {
        return false;
      }
      // Then filter by date - use Date object directly instead of toLocaleDateString()
      return formatDate(d.time_start) === formatDate(date);
    });

    return (
      <Grid item xs={12} style={{ padding: 10, borderTop: '1px solid ' }}>
        <button
          type="button"
          onClick={() => {
            if (filteredData.length > 0) {
              setCalendarDialog({
                open: true,
                data: filteredData,
                date: isCurrentDate,
              });
            }
          }}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            width: '100%',
          }}
        >
          <Grid container direction={'row'} spacing={2}>
            <Grid item style={{ alignSelf: 'center' }}>
              <div
                style={{
                  backgroundColor: isCurrentDate ? '#1EB3D9' : 'transparent',
                  color: isCurrentDate ? 'white' : index === 28 && getDayNumber(date) < 28 ? '#B0B0B0' : 'black',
                  display: isCurrentDate ? 'inline-flex' : '',
                  padding: isCurrentDate ? 2 : '',
                  borderRadius: 5,
                }}
              >
                <Typography variant="caption">{getDayNumber(date)}</Typography>
              </div>
            </Grid>
            <Grid item container direction={'row'}>
              {' '}
              {filteredData
                ?.filter((d) => {
                  if (search === '') {
                    return d;
                  }
                  return d.title.toLowerCase().includes(search.toLowerCase());
                })
                .map((d, index) => {
                  if (index < 3) {
                    return (
                      <div
                        key={`verification-${d.id || index}`}
                        style={{
                          color: 'white',
                          marginRight: 5,
                          padding: 5,
                          borderRadius: 5,
                          backgroundColor:
                            d.schedule === 'Daily' ? '#1EB3D9' : d.schedule === 'Weekly' ? '#8667EB' : '#F9A207',
                          cursor: 'pointer',
                        }}
                      >
                        <Grid item container direction={'row'}>
                          <Grid item>
                            <FolderCopyIcon style={{ color: 'white', height: 12, width: 12 }} />
                          </Grid>
                          <Grid item>
                            <Typography variant="caption">
                              {d.title.length > 10 ? `${d.title.slice(0, 10)}...` : d.title}
                            </Typography>
                          </Grid>
                        </Grid>
                      </div>
                    );
                  }
                  return null;
                })}
              {filteredData?.length <= 3 || filteredData?.length === undefined ? (
                ''
              ) : (
                <Link onClick={() => {}}>
                  <Typography variant="caption" style={{ cursor: 'pointer' }}>
                    {filteredData?.length - 3} more
                  </Typography>
                </Link>
              )}{' '}
            </Grid>
          </Grid>
        </button>
      </Grid>
    );
  }

  const NewArray = ({ daysArray }) => {
    const rows = [];

    const getDaysArrayByMonth = (year, month) => {
      const daysInMonth = new Date(year, month, 0).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => new Date(year, month - 1, i + 1));
    };

    const remainingDays = 35 - daysArray.length;

    const nextMonth = getDaysArrayByMonth(year, month + 1);

    const paddedDaysArray = [...daysArray, ...nextMonth.slice(0, remainingDays)];

    for (let i = 0; i < paddedDaysArray.length; i += 1) {
      const rowDays = paddedDaysArray.slice(i, i + 1);
      rows.push(rowDays.map((day, index) => <DayCardRight key={`day-right-${i}-${index}`} date={day} index={i} />));
    }

    return rows;
  };
  function getMonthName(monthNumber) {
    const months = [
      t('month.1'),
      t('month.2'),
      t('month.3'),
      t('month.4'),
      t('month.5'),
      t('month.6'),
      t('month.7'),
      t('month.8'),
      t('month.9'),
      t('month.10'),
      t('month.11'),
      t('month.12'),
    ];

    if (monthNumber >= 1 && monthNumber <= 12) {
      return months[monthNumber - 1];
    }
    return 'Invalid Month';
  }
  function handleClose() {
    setCalendarDialog((current) => ({
      ...current,
      open: false,
    }));
  }

  return (
    <Grid container direction={'row'}>
      <Grid item xs={7} style={{ borderRight: '1px solid #E7E7E7' }}>
        <div>
          {
            <DialogCalendar
              open={calendardialog.open}
              data={calendardialog.data}
              handleClose={handleClose}
              date={calendardialog.date}
              refresh={Refresh}
            />
          }
          <Grid container direction="row" style={{ borderBottom: '1px solid #E7E7E7' }}>
            <Grid item container direction={'row'} xs={12} justifyContent={'space-between'}>
              <Grid item>
                {' '}
                <Typography component="h2" variant="h5" sx={{ p: 2, paddingLeft: 5 }}>
                  {t('Calendar.1')}
                </Typography>
              </Grid>
              <Grid item alignSelf={'center'}>
                <Typography component="h2" variant="h5" sx={{ p: 2, paddingRight: 5 }}>
                  {year}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} container direction={'row'} justifyContent={'center'} spacing={6}>
              <Grid item>
                {' '}
                <IconButton style={{ color: '#12A2CE' }} onClick={handlemonthback}>
                  <ArrowBackIosIcon />
                </IconButton>
              </Grid>
              <Grid item alignSelf={'center'}>
                {getMonthName(month)}
              </Grid>
              <Grid item>
                <IconButton style={{ color: '#12A2CE' }} onClick={handlemonth}>
                  <ArrowForwardIosIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>

          {}
          <DayList daysArray={daysArray} />
          {}
          {}
        </div>
      </Grid>
      <Grid item xs={5} container direction={'row'} style={{ padding: 20, maxHeight: 550, overflow: 'auto' }}>
        <Grid item xs={12}>
          <Typography>{t('VerifSchedule.1')}</Typography>
        </Grid>

        <Grid item xs={12} container direction={'row'} spacing={2} style={{ marginTop: 20 }}>
          {NewArray({ daysArray })}
        </Grid>
      </Grid>
    </Grid>
  );
}
